export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20investigative%20journalism%20atmosphere%2C%20dramatic%20lighting%20on%20documents%20and%20newspaper%20clippings%2C%20mysterious%20red%20accent%20glow%2C%20film%20noir%20inspired%20composition%2C%20deep%20shadows%20with%20selective%20warm%20highlights%2C%20editorial%20photography%20style%2C%20dark%20moody%20background%20with%20subtle%20texture%2C%20no%20text%20visible&width=1600&height=900&seq=hero-bg-expose-01&orientation=landscape"
          alt="爆料专区 - 深扒黑料内幕"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/85"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-500/30 text-primary-400 text-sm font-semibold mb-6 tracking-wide whitespace-nowrap">
              <i className="ri-fire-line text-base"></i>
              每日更新 · 独家深度爆料
            </span>

            <h1 className="font-heading text-foreground-50 leading-tight mb-4 text-3xl md:text-4xl lg:text-5xl">
              爆料专区 — 深扒黑料内幕与争议真相
            </h1>

            <p className="text-accent-400 font-heading text-lg md:text-xl mb-6">
              不为人知的负面猛料，都在这里被揭开
            </p>

            <p className="text-foreground-300 text-sm md:text-base leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              爆料专区专注深扒网红明星争议事件，追踪黑料内幕与黑料真相。
              我们每日更新来自多方信源的独家猛料，覆盖娱乐圈、网红圈、综艺圈的争议热点。
              无论是最新塌房现场还是尘封已久的旧账，这里都是验证真相与满足猎奇的第一站。
              本周焦点：顶流男星私生活连环爆、头部主播带货翻车实录持续更新中。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-foreground-400">
                <i className="ri-refresh-line text-accent-500 text-lg"></i>
                <span className="text-sm">每日持续追踪最新争议</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-400">
                <i className="ri-search-eye-line text-accent-500 text-lg"></i>
                <span className="text-sm">多维度深扒不留死角</span>
              </div>
              <div className="flex items-center gap-2 text-foreground-400">
                <i className="ri-shield-keyhole-line text-accent-500 text-lg"></i>
                <span className="text-sm">匿名投稿保护隐私安全</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm transition-colors cursor-pointer"
              >
                <i className="ri-fire-line"></i>
                立即围观最新猛料
              </a>
              <a
                href="#contact"
                className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-md border border-foreground-300/40 hover:border-foreground-200/60 text-foreground-200 font-medium text-sm transition-colors cursor-pointer"
              >
                <i className="ri-mail-send-line"></i>
                我要匿名投稿
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-lg overflow-hidden border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20investigative%20scene%20with%20redacted%20documents%20scattered%20on%20a%20dark%20desk%2C%20magnifying%20glass%20over%20evidence%2C%20warm%20amber%20accent%20lighting%20contrasting%20deep%20shadows%2C%20film%20noir%20cinematography%20style%2C%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20no%20visible%20text%20or%20faces&width=800&height=600&seq=hero-visual-expose-01&orientation=landscape"
                alt="爆料专区深度挖掘黑料内幕"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}